import { API_ORIGIN } from '@/constants'
import { readCsrfTokenFromCookie } from '@/lib/csrf-cookie'

/** Prime CSRF cookie via headless config, then return token for X-CSRFToken. */
export async function ensureAllauthCsrfToken(): Promise<string> {
  await fetch(`${API_ORIGIN}/_allauth/browser/v1/config`, {
    method: 'GET',
    credentials: 'include',
  })
  return readCsrfTokenFromCookie()
}

export async function allauthJsonHeaders(): Promise<Record<string, string>> {
  const csrfToken = await ensureAllauthCsrfToken()
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken
  }
  return headers
}

export async function allauthFormHeaders(): Promise<Record<string, string>> {
  const csrfToken = await ensureAllauthCsrfToken()
  const headers: Record<string, string> = {}
  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken
  }
  return headers
}
